import { EventName } from '@lit/react';
import { BlocksSegmentedControlItem } from 'blocks-nextjs/blocks-web-components/components/segmented-control-item/segmented-control-item';
import { BlocksSegmentItemSelect } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatSegmentedControlItem = createComponent({
  react: React,
  tagName: 'cat-segmented-control-item',
  elementClass: BlocksSegmentedControlItem,
  events: {
    onBlSegmentItemSelect: 'bl-segment-item-select' as EventName<BlocksSegmentItemSelect>
  }
});
